export default "__VITE_ASSET__7dd7d440__"